import {Pipe, PipeTransform} from '@angular/core';
import {SubFamilyDto} from '../../../Models/Tasks/General/task.interface';
import {FieldTypesEnum} from '../../../Shared/Enum/field-types.enum';

@Pipe({
  name: 'tasksSubfamily',
  standalone: false
})
export class TasksSubfamilyPipe implements PipeTransform {

  transform(items: SubFamilyDto[], filters: { menu: string }): SubFamilyDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filters.menu === 'incidents') {

      items = items.filter((subfamily) => subfamily.campos.some((field) => field.observaciones));

    }

    if (filters.menu === 'pendents') {

      items = items.filter((subfamily) => subfamily.campos.some((field) => !field.value && field.tipo !== FieldTypesEnum.title));

    }

    return items;

  }

}
